import { Component, Mixins, Vue } from "vue-property-decorator";

import { LangManager } from "@/lang";
import { UserModel } from "@/models";
// import { pb } from "@/network/pb/proto";

import Common from "@/controllers/admin/Common";

@Component<AdminUserIndexController>({
  components: {}
})
export default class AdminUserIndexController extends Mixins(Common) {
  private textHash!: { [page: string]: { [key: string]: string } };
  private data: object = {};

  public async created() {
    this.$data.textHash = LangManager.getTextHashByPage("user");
    this.$data.data = await UserModel.get();
    this.mixinsExample();
  }

  private redirectToEditPage(index: number) {
    window.location.href = "/admin/user/edit/" + index;
  }

  private confirmDelete(index: number) {
    const yes = confirm("confirm delete id " + this.$data.data[index].id + "?");
    if (yes) {
      this.deleteForm(index);
    }
  }

  private async deleteForm(index: number) {
    const errNo = await UserModel.delete(this.$data.data[index].id);
    if (errNo === 1) {
      window.location.href = "/admin/user";
    }
  }
}
